import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, of, switchMap } from 'rxjs';
import { Injectable } from '@angular/core';
import { PowerBiService } from '@cpd-app/core-module/services';

import * as PowerBiActions from './powerbi.actions';

@Injectable()
export class PowerBiEffects {
  public getEmbedConfig$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(PowerBiActions.getEmbedConfig),
      switchMap(() => {
        return this.powerBiService.getEmbedConfig().pipe(
          switchMap((config) => [
            PowerBiActions.getEmbedConfigSuccess({ embedConfig: config })
          ]),
          catchError((error) =>
            of(PowerBiActions.getEmbedConfigFailure({ error }))
          )
        );
      })
    );
  });

  constructor(
    private actions$: Actions,
    private powerBiService: PowerBiService
  ) {}
}
